import { TDeviceType } from '@cian/ui-kit';
import { EPlatform } from '@cian/webview/shared';

import { getSiteType } from './getSiteType';
import { EPageTypes } from '../constants/page';
import { EPageType } from '../types/redux/page';

export interface IGetPageviewObjectProps {
  deviceType: TDeviceType;
  userId?: number | null; // id текущего пользователя
  isGuest?: boolean; // Гостевой просмотр готового отчета (только для страницы готового отчета /valuation-report/:id)
  pageType?: EPageTypes;
  platform: EPlatform | null;
}

export const mapPageTypeToAnalytics: Record<EPageType, EPageTypes> = {
  [EPageType.Calculator]: EPageTypes.EstateCalculator,
  [EPageType.ReportCreator]: EPageTypes.EstateCalculatorB2B,
  [EPageType.ReportReady]: EPageTypes.EstateCalculatorB2BPreview,
  [EPageType.MyHomeDetailed]: EPageTypes.MyHomeDetailed,
  [EPageType.CalculatorSuburban]: EPageTypes.CalculatorSuburban,
  [EPageType.MyHomeSuburbanDetailed]: EPageTypes.MyHomeSuburbanDetailed,
};

export function getPageviewObject({ deviceType, userId, isGuest, pageType, platform }: IGetPageviewObjectProps) {
  const extra = platform ? { type: platform } : undefined;
  const page = {
    pageType: pageType || EPageTypes.EstateCalculatorB2B,
    siteType: getSiteType(deviceType),
    extra,
  };

  if (isGuest) {
    Object.assign(page, {
      extra: {
        viewer: 'guest',
      },
    });
  }

  return {
    user: {
      userId,
    },
    page,
  };
}
